import { render, staticRenderFns } from "./WithdrawalConfirm.vue?vue&type=template&id=e32d5878&"
import script from "./WithdrawalConfirm.vue?vue&type=script&lang=js&"
export * from "./WithdrawalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports